import React from 'react'
import { MobilePaginationBar } from '../../components/mobile'

const ChargeMobilePagination = ({ pagination, handlePagination }) => {
  return (
    <MobilePaginationBar
      current_page={pagination?.current_page}
      total_pages={pagination?.total_pages}
      onNavigate={handlePagination}
      ariaLabel="Paginación de cobros"
      disablePaper
    />
  )
}

export default ChargeMobilePagination
